import { Outlet, useLocation } from 'react-router-dom';
import { CursorProvider } from './CursorContext';
import { ToastContainer } from 'react-toastify';
import TopPanel from '@CommonFunctionalDisplay/TopPanel';
import SidePanel from '@CommonFunctionalDisplay/SidePanel';
import TopPanelAdmin from '@CommonFunctionalDisplay/TopPanelAdmin';
import SidePanelAdmin from '@CommonFunctionalDisplay/SidePanelAdmin';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import useThemeChange from '@Hooks/useThemeChange';
import './BaseOutlet.scss';

export default function BaseOutlet(){

    const location = useLocation();
    const { userType } = useReduxActiveUser();
    const className = 'baseOutlet';
    const isAdminContext = userType === 'admin';

    useThemeChange();

    return (
        <>
            <ToastContainer
                limit={1}
                containerId={'error'}
                position='bottom-left'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
                theme='light'/>
                <CursorProvider>
                    <div className={className}>
                        <div className={className + '__main'}>
                            {
                                location.pathname !== '/home' &&
                                    <>
                                        {isAdminContext ? <TopPanelAdmin /> : <TopPanel />}
                                        {isAdminContext ? <SidePanelAdmin /> : <SidePanel />}
                                    </>
                            }
                            <div className={className + (location.pathname !== '/home' ? '__main__section' : '')} style={{ flex: 1 }}>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </CursorProvider>
        </>
    );
};
